var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineComponent as _defineComponent } from 'vue';
import {} from "@/api/configTemplates";
import VaultSecret from "./VaultSecret.vue";
import FormCard from "@/components/Form/FormCard.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'EditSecretsForm',
    props: {
        template: null,
        title: null
    },
    emits: ["update"],
    setup(__props, { emit }) {
        function update(secretName, secretValue) {
            return __awaiter(this, void 0, void 0, function* () {
                emit("update", secretName, secretValue);
            });
        }
        return { __sfc: true, emit, update, VaultSecret, FormCard };
    }
});
